import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowWithTail = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 14,
	viewBox: "0 0 16 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.7128 13.6935C8.80381 13.7313 8.90146 13.7505 9 13.75C9.09854 13.7505 9.19618 13.7313 9.28719 13.6935C9.3782 13.6557 9.46075 13.6001 9.53 13.53L15.5112 7.54881C15.5177 7.54278 15.5241 7.53663 15.5303 7.53036C15.671 7.38971 15.75 7.19894 15.75 7.00003C15.75 6.80112 15.671 6.61035 15.5303 6.4697C15.5241 6.46344 15.5177 6.4573 15.5112 6.45128L9.53 0.470029C9.38782 0.337549 9.19977 0.265426 9.00547 0.268855C8.81117 0.272283 8.62579 0.350995 8.48837 0.488408C8.35096 0.625821 8.27225 0.811206 8.26882 1.00551C8.26539 1.19981 8.33752 1.38785 8.47 1.53003L13.19 6.25003H1C0.801088 6.25003 0.610322 6.32905 0.46967 6.4697C0.329018 6.61035 0.25 6.80112 0.25 7.00003C0.25 7.19894 0.329018 7.38971 0.46967 7.53036C0.610322 7.67101 0.801088 7.75003 1 7.75003H13.19L8.47 12.47C8.32955 12.6107 8.25066 12.8013 8.25066 13C8.25066 13.1988 8.32955 13.3894 8.47 13.53C8.53924 13.6001 8.62179 13.6557 8.7128 13.6935Z"
	})]
});
const ForwardRef = forwardRef(SvgArrowWithTail);
export { ForwardRef as ReactComponent };
